import React, { useEffect, useState } from "react";

import Navigation from "../navigation/mainNavBar";

import "../footer/Policy.scss";

import Footer from "../footer/Footer";

import ArticleNavigation from "./Navigation";

const data = [
  { name: "ZAŁOŻENIA OGÓLNE", id: "main", depth: 1 },
  { name: "ZAKAZY", id: "bans", depth: 2 },
  { name: "ADMINISTRACJA", id: "admin", depth: 1 },
  { name: "STANY BW", id: "bw", depth: 1 },
  { name: "POWALONY", id: "bw1", depth: 2 },
  { name: "RANNY", id: "bw2", depth: 2 },
  { name: "MARTWY", id: "bw3", depth: 2 },
  { name: "TRWAŁA ŚMIERĆ", id: "death", depth: 1 },
  { name: "FCK PRZEZ GRACZA", id: "death1", depth: 2 },
  { name: "FCK PRZEZ LEKARZA", id: "death2", depth: 2 },
  { name: "DZIENNICZEK DOBREGO RP", id: "terms", depth: 1 },
  { name: "OUT OF CHARACTER", id: "ooc", depth: 2 },
  { name: "RANDOM DEATHMATCH", id: "rdm", depth: 2 },
  { name: "METAGAMING", id: "mg", depth: 2 },
  { name: "POWERGAMING", id: "pg", depth: 2 },
  { name: "IMIONA POSTACI", id: "name", depth: 2 },
  { name: "PORWANIA", id: "kidnap", depth: 2 },
  { name: "AMNEZJA", id: "amnesia", depth: 2 },
  { name: "INICJACJA", id: "initial", depth: 2 },
  { name: "LIMITY", id: "limits", depth: 1 },
  { name: "NAPAD NA BANK", id: "limit1", depth: 2 },
  { name: "NAPAD NA SKLEP", id: "limit2", depth: 2 },
  { name: "KOPANIE GROBÓW", id: "limit3", depth: 2 },
  { name: "SADZENIE KONTRABANDY", id: "limit4", depth: 2 },
  { name: "PEDZENIE BIMBRU", id: "limit4", depth: 2 },
  { name: "SPRZEDAŻ KONTRABANDY", id: "limit5", depth: 2 },
  { name: "CRIME", id: "limit6", depth: 2 },
  { name: "SZERYOWIE", id: "limit7", depth: 2 },
  { name: "CYWILE", id: "limit8", depth: 2 },
  { name: "NAPADY", id: "robbery", depth: 1 },
  { name: "KONWOJE", id: "convoy", depth: 1 },
  { name: "SKLEPY", id: "shops", depth: 1 },
  { name: "CRIME", id: "crime", depth: 1 },
  { name: "SZCZEGÓŁY", id: "details", depth: 1 },
  { name: "FRAKCJE", id: "factions", depth: 1 },
];

function Rules() {
  useEffect(() => {
    const sectionOffset =
      document.querySelector("section:first-of-type").offsetTop * 0.8;
    window.scrollTo({
      top: sectionOffset,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="Rules">
      <Navigation />
      <div className="content">
        <div className="title">WildLandsRP</div>
        <div className="sub-title">
          Przyjaciele, wrogowie i fortuna czekają na Ciebie!
        </div>
        <div className="main-butons-line"></div>
      </div>
      <div className="section-title">
        Zasady panujące na serwerze WildLandsRP.pl
      </div>
      <section className="grid2">
        <div className="grid-item">
          <ArticleNavigation data={data}></ArticleNavigation>
        </div>
        <div className="grid-item">
          <h2 id="main">Założenia ogólne</h2>
          <p>
            Jeśli w grze pojawią się nieporozumienia lub przypadki łamania
            zasad, wszyscy członkowie danej akcji powinni spróbować odegrać
            aktualną akcje RP do końca. Po zakończeniu akcji członkowie mogą
            wejść na discord’a serwera, w celu zgłoszenia danego nieporozumienia
            lub łamania zasad.
          </p>
          <p>
            Jeśli problem jest pilny i musi zostać rozwiązany natychmiast,
            możesz skontaktować się z członkiem administracji/moderacji, poprzez
            wejście na kanał poczekalni na serwerze Discord oraz utworzenie
            ticket’a.
          </p>
          <p>
            Jeśli uważasz, że gracz złamał zasadę, prześlij zgłoszenie za pomocą
            funkcji utworzenia ticket’a na naszym serwerze Discord. Pamiętaj że
            musisz posiadać odpowiednie dowody.
          </p>
          <p>
            Jeśli twoja ogólna umiejętność odgrywania RP zostanie uznana za zbyt
            niską lub niespójną dla serwera po otrzymaniu whitelist, twój dalszy
            pobyt na serwerze będzie zależał od głosowania w gronie
            administracji. Jeśli twoje zachowanie zostanie uznane za szkodliwe
            dla ogólnej jakości serwera, możesz zostać ukarany.
          </p>
          <p>
            Wykorzystywanie błędów, exploitów, hacków dla osobistych korzyści
            spowoduje nałożenie permanentnej blokady na konto. Nie będzie
            tolerancji dla hakowania, w tym między innymi resources/scripts
            injection, będzie skutkować permanentnym banem. Jeśli okaże się, że
            znalazłeś błąd, exploit, lub coś co nie powinno być na serwerze,
            masz obowiązek zgłosić to administracji.
          </p>
          <p>
            Wypowiadanie treści rasistowskich/ homofobicznych/ transfobicznych/
            seksistowskich oraz treści zabronionych na serwisach streamingowych
            np. Twitch jest surowo zakazane i będzie karane bardzo surowymi
            karami. Tyczy się to tak samo OOC jak i IC.
          </p>
          <p>
            Po otrzymanym BW pojawia nam się panel opisu stanu postaci, nie
            służy on do przekazywania informacji takich jak np. “Co doprowadziło
            cię do obecnego stanu”, lecz do opisania jakie obrażenia odniosła
            twoja postać. Opisy niezgodne z tą sytuacją będą karane.
          </p>
          <p>
            Trzymamy się reguły, że na serwerze obowiązuje rok 1898.
            Niedostosowanie słownictwa jak i zachowania do wskazanego roku
            będzie karane.
          </p>
          <p>Minimalny wiek odgrywanej postaci wynosi 20 lat.</p>
          <p>
            Utrzymując immersję pamiętajcie, że doprowadzając do jakiejkolwiek
            akcji na zaludnionym obszarze, gracze mają prawo dowiedzieć się od
            przebywających tam ludzi (NPC) o przebiegu akcji, która się tam
            wydarzyła. Dzieje się to poprzez odegranie na komendach narracyjnych
            /me, /do oraz /try. Osoba pytająca, powinna skonstruować odpowiednie
            pytanie na /do, a osoba, biorąca udział w akcji, ma obowiązek
            odpowiedzieć na to pytanie zgodnie z prawdą, przy użyciu komend
            narracyjnych. Należy jednak pamiętać, aby tego nie nadużywać i robić
            to ze smakiem.
          </p>
          <p>
            Jeżeli dany gracz odegrał, że zasypia w swoim domu i chce, aby było
            to respektowane przez innych graczy, powinien zostawić informację z
            pomocą komendy /detail. Jeżeli gracze, postanowią wejść w interakcje
            z domem, w którym znajduje się detail, informujący o obecności
            gracza, będzie to traktowane, jako FailRP.
          </p>
          <p>
            Osoba która była zamaskowana w trakcie akcji może zostać rozpoznana
            do 90 min po akcji. Rozpoznać można tę osobę tylko po ubiorze o ile
            wcześniej go nie zmieniła, po upływie tego czasu nie jesteśmy w
            stanie zweryfikować tej osoby. Zakazane jest rozpoznawanie osób po
            głosie, koniu, bądź broniach.
          </p>
          <p>
            Wszystkie rzeczy jakie gracz zrobi na poczet serwera typu:
            regulaminy frakcji, pomysły na prace, biznesy, eventy i przekazuje
            je serwerowi, nie może rościć do nich praw autorskich. Po wdrożeniu
            tego na serwer, należy to do właścicieli serwera.
          </p>
          <p>
            Gracze obowiązkowo muszą zapoznać się z kanałem #informacje oraz
            zawartymi na nim plikami oraz filmami. Nieznajomość treści może
            spotkać się z konsekwencjami OOC.
          </p>
          <p>
            Zakaz używania tak zwanego “gównoslangu”, to jest odnoszenie się do
            rzeczy OOC, poprzez czat głosowy w grze np. “słyszysz mnie”, “gardło
            Pana boli”, “zamyślam się”, “coś Pana nie słychać” do tego służy
            czat local-OOC.
          </p>
          <p>Gwałtowna zmiana wyglądu postaci, będzie uznawana jako failRP.</p>
          <p>
            Zakazane jest tworzenie kolejnej postaci, która ma jakiekolwiek
            powiązania z inną postacią danego gracza.
          </p>
          <p>
            Zakazane jest odgrywanie identycznych lub bardzo podobnych postaci
            do posiadanych lub uśmierconych.
          </p>
          <p>
            Zakazane jest powracanie do tej samej grupy przestępczej/frakcji po
            uśmierceniu poprzedniej postaci przez minimum 2 tygodnie.
          </p>
          <p>
            Aby trwale uszkodzić jakikolwiek budynek, potrzebna jest uprzednia
            zgoda wydana przez administracje na tickecie.
          </p>
          <p>
            Administracja rozpatruje sprawy, które zostały zgłoszone nie później
            niż 72h od momentu zdarzenia. Punkt nie obowiązuje cheatów, bugów,
            exploitów.
          </p>
          <p>
            Gracze mają obowiązek ustawić na Discordzie taką samą lub bardzo
            podobną nazwę użytkownika, jak ta posiadana na serwerze. Używane
            nazwy nie mogą zawierać wymyślnych czcionek, obcych alfabetów i
            innych znaków specjalnych uniemożliwiających proste wyszukanie nazwy
            na discordzie lub na serwerze.
          </p>
          <p id="bans">Podczas rozgrywki na serwerze, zakazuje się:</p>
          <ul>
            <li>Oglądania streamów z serwera.</li>
            <li>Przesiadywania na wszelakich komunikatorach głosowych.</li>
          </ul>
          <p>
            Zakazuje się “cichego grindu” np. Pracowanie w kopalni bez
            jakiejkolwiek reakcji na otoczenie, bycie głuchym na próbę
            nawiązania rozmowy. Tyczy się to również zostawiania postaci AFK w
            punktach centralnych, gdzie inni gracze mogą chcieć nawiązać
            interakcję.
          </p>
          <p>
            Jeśli osoba będąca AFK zostanie przez kogoś znaleziona, przeszukiwana,
            zaatakowana, potrącona na szlaku, etc. odpowiada sama za siebie.
            Administracja nie przyjmuje zgłoszeń w formie ticket'a od takich osób.
            Jedyne czym Administracja się zajmie to to, czy przebieg takiego
            zdarzenia był zgodny z regulaminem.
          </p>
          <p>
            Zakazane jest odgrywanie pozostawiania rzeczy bez ich odłożenia. To
            co gracz posiada przy sobie ma faktycznie przy sobie.{" "}
          </p>
          <p>
            Wyciąganie lub chowanie rzeczy z/do tak zwanego buta lub pod
            płaszcza jest zakazane i będzie uznawane za FailRP.{" "}
          </p>
          <p>
            Podczas wyciągania rzeczy z innego wozu gracza, nakazane jest użycie
            komend narracyjnych.
          </p>
          <p>
            Istnieje możliwość spisania testamentu na drobne lub specjalne
            rzeczy np. zegarek, grawerowana broń itp. Poprzez uprzednie spisanie
            testamentu u burmistrza. Zakazuje się przekazywania majątku przed
            planowaną przerwą w grze bądź CK postaci.
          </p>
          <p>
            Zabrania się podejmowania działań o charakterze hostylnym (wrogim), prowokacyjnym lub agresywnym wobec innych graczy w bezpośrednim sąsiedztwie Wioski Indian Wapiti.
          </p>
          <p>
            Zakazuje się wykorzystywania Wioski Indian Wapiti jako miejsca ucieczki przed konsekwencjami działań RP, takich jak pościgi, starcia frakcyjne itp.
          </p>
          <p>
            Wyjątek od powyższych zasad stanowi zgoda administracji, wydawana indywidualnie na potrzeby konkretnych scenariuszy fabularnych lub eventów.
          </p>
          <h2 id="admin">Administracja</h2>
          <p>
            Wszelka komunikacja z administracja WildLandsRP powinna być
            traktowana poufnie(nie powinna być nikomu spoza niej udostępniana).
            Jako administracja oczekujemy, że wszelka formalna komunikacja
            będzie traktowana z szacunkiem i kulturą osobistą. Każdy członek
            społeczności, który łamie te zasady komunikacji z administracją,
            może podlegać karze.
          </p>
          <p>
            Wszystkie sprawy do administracji zgłaszamy za pomocą ticket’a na
            naszym discordzie. Wszelkie wiadomości prywatnej w postaci spamu,
            lub zbędnych wiadomości do administracji w prywatnych wiadomościach
            na discordzie, może zostać ukarana.
          </p>
          <p>
            Administrator ma prawo karać, za czyny które nie są uwzględnione w
            regulaminie, według własnych przekonań. Administracja ma prawo
            zbanować i usunąć z whitelist’y każdego bez podawania przyczyny.
          </p>
          <p>
            Każdy członek Administracji rozpatruje sytuację w oparciu o regulamin i własną interpretację.
            Wystawia blokadę według własnej oceny.Taryfikator to dodatkowa pomoc dla Administratora.
          </p>
          <h2 id="bw">Stany BW</h2>
          <ul>
            <li id="bw1">
              <strong>„Powalony”</strong> - jest to gracz, który jest
              kontuzjowany, lub został pobity i leży na ziemi, ale nadal jest w
              stanie komunikować się głosowo. Gracze w tym stanie będą mieć
              pełną pamięć o wszystkim, co przydarzy im się podczas powalenia.
              (Stan ten trwa 60s)
            </li>
            <li id="bw2">
              <strong>„Ranny”</strong> - jest to gracz, który jest ranny,
              poprzez np. Postrzał, upadek z wysokości itp. Gracze po otrzymaniu
              tego stanu, muszą dokładnie opisać swoje urazy w karcie “stanu
              postaci”. Gracze w tym stanie nie mogą przekazywać sobie
              informacji na temat położenia pozostałych przeciwników. Gracz,
              któremu nie zostanie udzielona pomoc Lekarza ma możliwość
              odgrywania amnezji.
            </li>
            <li id="bw3">
              <strong>„Martwy”</strong> - jest to gracz, który jest nieprzytomny
              i leży na ziemi oraz użył /do do wpisania „Brak pulsu” lub
              równoznacznej frazy, w której postać nie może zostać reanimowana.
              Gdy gracz wyraźnie wskazuje na śmierć postaci, nie ma odwrotu.
              Mogą pozostać zalogowani na tej postaci, aby udostępnić ciało do
              dalszego RP, ale ta postać powinna pozostać na stałe martwa.
              Gracze muszą zapomnieć o wszystkich informacjach, które martwe
              postacie znały podczas tworzenia nowej postaci. Co więcej, gracze
              muszą unikać przebywania innej postaci w obszarze/lokalizacji,
              gdzie wciąż rozgrywa się akcja RP dotycząca śmierci twojej
              postaci.
            </li>
          </ul>
          <p>
            Przez cały czas na serwerze musisz cenić swoje życie i życie innych.
            Postacie powinny postępować zgodnie ze swoją osobowością i manierami
            w obliczu zagrożenia dla ich życia, ale zawsze muszą próbować
            ratować własne życie i ograniczać szkody wyrządzone życiu innych.
          </p>
          <p>
            Częste uczestnictwo w bójkach lub inne brutalne/niebezpieczne
            zachowanie, które może prowadzić do poważnych obrażeń lub śmierci,
            może być uznane za brak poszanowania życia.
          </p>
          <p>
            Administracja z przyjemnością wyjaśni wszelkie nieporozumienia i
            udzieli graczom ostatecznej odpowiedzi, czy określone zachowania
            można uznać za nieposzanowanie życia.
          </p>
          <h2 id="death">Trwała Śmierć</h2>
          <p id="death1">
            Gracze nie mogą zmuszać nikogo do trwałego zabicia ich postaci.
            Chyba że mają konkretną zgodę administracji lub graczy, z którymi
            wchodzą w interakcję. Trwała śmierć może nastąpić w następujących
            przypadkach:
          </p>
          <ul>
            <li>
              Trwała śmierć postaci za zgodą OOC wszystkich zaangażowanych
              stron.
            </li>
            <li>
              Roleplay/efekt rozgrywki. Zwykle wiąże się to z tymczasowymi
              konsekwencjami, takimi jak obrażenia, niewola, rabunek lub inne
              rozwiązanie, które pozwala graczowi decydować o swoim ostatecznym
              losie w późniejszym czasie.
            </li>
          </ul>
          <p id="death2">
            Lekarz ma prawo do wykonania FCK na graczu, któremu pomaga w wyniku
            BW. Jeśli:
          </p>
          <ul>
            <li>
              rany odniesione przez gracza są na tyle poważne, że przerastają
              możliwości leczenia w 1898 r.
            </li>
            <li>
              ilość ran oraz obrażeń jest zbyt wielka by postać mogła je przeżyć
            </li>
            <li>
              zostały uszkodzone ważne narządy wewnętrzne, bez których postać
              nie jest w stanie funkcjonować
            </li>
          </ul>
          <h2 id="terms">Dzienniczek dobrego roleplay’owca</h2>
          <h3 id="ooc">Out Of Character(OOC)</h3>
          <p>
            Przebywając na serwerze, musisz pozostać w postaci przez cały czas.
            Ignorowanie interakcji z innymi osobami na serwerze jest uważane za
            zepsucie postaci i „fail rp”. Czat OOC - Jest to czat techniczny
            używany do informowania bądź zgłaszania problemów innym graczom w
            grze lub poza nią
          </p>
          <h3 id="rdm">Random Deathmatch(RDM)</h3>
          <p>
            Jest to celowa agresywna akcja przeciwko graczowi lub NPC
            (Non-Player Character), która jest inicjowana bez wcześniejszej
            interakcji werbalnej. Przykłady tego obejmują, ale nie ograniczają
            się do lin/skrępowania, strzelania, dźgania i/lub uderzania oraz
            tratowanie konno lub wozem. Nie powinno się również planować ani
            dyskutować o strzelaniu/popełnianiu przestępstwa w otoczeniu
            postronnych osób. Nieprzestrzeganie tej zasady będzie skutkować
            odpowiednią karą.
          </p>
          <h3 id="mg">Metagaming(MG)</h3>
          <p>
            Jest to wykorzystanie czynników zewnętrznych, informacji lub wiedzy,
            której twoja postać nie byłaby w stanie uzyskać w normalny sposób.
            Obejmuje to między innymi informacje uzyskane za pośrednictwem
            transmisji na żywo, filmów i kanałów tekstowych OOC zarówno w
            Discord, jak i w grze. Korzystanie z Z’etki(sprawdzanie ID
            okolicznych graczy) w celu zdobycia informacji oraz przewagi nad
            resztą. Granie na serwerze i w tym samym czasie oglądanie streamów z
            serwera, jest zabronione i będzie skutkować surową karą. Metagaming
            obejmuje wykorzystanie wiedzy o fabuły zdobytej na jednej postaci i
            zastosowanie jej na innej. Alternatywne postacie powinny mieć
            całkowicie oddzielne fabuły, a informacje nie powinny być
            udostępniane innym postaciom gracza, ponieważ każdy z nich jest
            zupełnie inną osobą.
          </p>
          <h3 id="pg">Powergaming(PG)</h3>
          <p>
            Powergaming jest to wykorzystywanie mechaniki gry do uzyskania
            przewagi bądź wymuszenie akcji na drugim graczu bez jego zgody. Jest
            to również próba ciągłego maksymalizowania swojej zdolności do
            wygrywania tzw. “Mustwin”, wszystkich akcji, kosztem zabawy i
            rozgrywki innych graczy. Niektóre przykłady tego problematycznego
            zachowania obejmują między innymi: Nigdy nie przegrywając walki.
            Nadużywanie lassa i bolasów. Twoja postać zawsze pamięta każdy
            szczegół po BW. Zawsze oczekuje, że ofiary nie będą pamiętały
            zbrodni. Gracze wykazujący którekolwiek z tych zachowań będą
            podlegać karze. Zakazane jest również Erotic Power Gaming(EPG),
            czyli napaści na ludzi w celach seksualnych.
          </p>
          <h3 id="me">Komenda /me</h3>
          <p>
            Opis wykonywanej czynności niepopartej animacją np. /me schyla się i
            zawiązuje buty.
          </p>
          <h3 id="do">Komenda /do</h3>
          <p>
            Opis stanu postaci/otoczenia np. /do zawiązał niechlujnie buty lub
            /do widać, że facet się stresuje. W wypadku otoczenia można użyć tej
            komendy w np. miejscu postrzału itd. /do widać krew na ziemi lub /do
            widać ślady po strzałach na ścianie.
          </p>
          <h3 id="try">Komenda /try</h3>
          <p>
            Losuje nam szansę 50/50. Komenda która urozmaica roleplay np. /try
            czy udało mu się zawiazać buty? Na czacie pojawi się wtedy "odniósł
            sukces próbując" albo "zawiódł prójąc".
          </p>
          <h3 id="opis">Komenda /opis</h3>
          <p>
            Długotrwaly opis Twojej postaci, opisujący co widać, a czego nie
            można zobaczyć w grze np. /opis ma podartą koszulę.
          </p>
          <h3 id="name">Imiona postaci</h3>
          <p>
            Imiona postaci na WildLandsRP powinny być autentyczne i powinny być
            twoją własną, niepowtarzalną kreacją. Używanie dokładnie
            odtworzonych imion postaci z już istniejących filmów, powieści,
            programów telewizyjnych lub innych odniesień do popkultury i
            historii jest zabronione. Postacie mogą mieć imię o wartości
            komediowej lub satyrycznej, ale powinny być wykonane gustownie.
            Jeśli masz jakiekolwiek pytania dotyczące nazywania postaci, wyślij
            ticket.
          </p>
          <h3 id="kidnap">Porwania/Zatrzymania</h3>
          <p>
            <ul>
              <li>
                Gracze powinni kierować się zdrowym rozsądkiem, gdy są spętani,
                jeśli twoja postać nie może realistycznie i bezpiecznie uciec,
                nie powinieneś próbować ucieczki. Gracze generalnie nie powinni
                wyrywać się z niewoli, chyba że:
                <ul>
                  <li>
                    Strona przeciwna jest poza zasięgiem krzyku (32 metry).
                  </li>
                  <li>
                    Strona przeciwna zostawiła cię samego w pomieszczeniu na
                    dłuższy czas.
                  </li>
                  <li>
                    Następuje poważne odwrócenie uwagi, takie jak strzały lub
                    eksplozje.
                  </li>
                </ul>
              </li>
              <li>
                Używanie lassa bądź kajdanek należy stosownie odegrać za pomocą
                komend narracyjnych /me, /do. Wyjątkiem od tej reguły jest
                pościg który wcześniej został zainicjowany.
              </li>
              <li>
                Osoby porwane które będą transportowane na koniu muszą być
                związane lassem. Siedzenie na koniu oraz odgrywanie związanego
                poprzez /opis jest zakazane.
              </li>
              <li>
                Używanie ludzi jako żywych tarczy poprzez noszenie ich na
                plecach jest zakazane.
              </li>
              <li>
                Osoby odgrywające zakutych poprzez /opis nie powinny biegać ani
                skakać.
              </li>
            </ul>
          </p>
          <h3 id="amnesia">Amnezja</h3>
          <p>
            Jeżeli gracz chce zmusić drugiego gracza do odgrywania amnezji,
            powinien uzyskać zgodę i odegrać to przy użyciu komend narracyjnych
            (/me, /do, /try). Obie strony mają możliwość użycia komendy /try.
            Gracz zmuszony do odgrywania amnezji nie jest w stanie pamiętać
            sytuacji która doprowadziła go do stanu BW.. Jeżeli nie ma
            bezpośredniej zgody na amnezje ze strony gracza, ostateczny los
            przejmuje komenda /try.
          </p>
          <h3 id="initial">Inicjacja</h3>
          <p>
            Każda akcja, powinna być zapoczątkowana odpowiednią inicjacją
            SŁOWNĄ, w wyjątkowych sytuacjach, inicjacją może być również
            wycelowanie bronią do drugiej osoby, gdy odległość pomiędzy
            postaciami, nie jest znacząca. Podczas akcji dynamicznych inicjacją
            może być również oddanie strzału w powietrze oraz odczekanie 10
            sekund.
          </p>
          <p>
            Aby być aktywnym uczestnikiem akcji hostylnej, niewystarczające jest
            powiązanie z jedną z uczestniczących stron, należy włączenie się do
            akcji, uprzedzić odpowiednią inicjacją np. gdy w banku znajduje się
            trzech napastników a pozostała dwójka znajduje się na dachu innego
            budynku, podczas strzelaniny lub zerwania negocjacji są zobowiązani
            również do zainicjowania.
          </p>
          <p>Aby dokonać inicjacji, należy spełnić następujące warunki:</p>
          <ul>
            <li>Osoba atakowana musi mieć czas na reakcje.</li>
            <li>
              Napastnik musi jasno przedstawić swoje żądania, które mogę być
              spełnione przez osobę atakowaną.
            </li>
            <li>
              Napastnik musi mieć widoczną broń lub wzbudzać zagrożenie u osoby
              atakowanej, może do tego użyć przewagi liczebnej.
            </li>
            <li>Akcja nie może zostać wykonana przy użyciu pojazdu</li>
          </ul>
          <h2 id="limits">Limity akcji</h2>
          <h3 id="limit1">Napad na bank</h3>
          <ul>
            <li>5 Crime</li>
            <li>
              6 Szeryfów (lecz szósta osoba jest tylko podczas negocjacji, nie
              może brać udziału w pościgu)
            </li>
          </ul>
          <h3 id="limit2">Napad na sklep </h3>
          <ul>
            <li>3 Crime</li>
            <li>
              4 Szeryfów (lecz czwarta osoba jest tylko podczas negocjacji, nie
              może brać udziału w pościgu)
            </li>
          </ul>
          <h3 id="limit3">Kopanie grobów </h3>
          <ul>
            <li>3 Crime</li>
            <li>3 Szeryfów</li>
          </ul>
          <h3 id="limit4">Sadzenie kontrabandy i Pędzenie bimbru</h3>
          <ul>
            <li>4 Crime</li>
            <li>4 Szeryfów</li>
          </ul>
          <h3 id="limit5">Sprzedaż kontrabandy</h3>
          <ul>
            <li>2 Crime</li>
            <li>2 Szeryfów</li>
          </ul>
          <br /> <br />
          <h3 id="limit6">Crime</h3>
          <p>
            Maksymalnie 5 członków w dowolnej grupie graczy podczas akcji
            hostylnych. Przestępcy mogą spotykać się w grupach większych niż 5,
            ale nie powinni brać udziału w strzelaninach/walkach i innych
            akcjach hostylnych bez zgody administracji. Zatwierdzenie można
            otrzymać za pośrednictwem ticket’a.
          </p>
          <h3 id="limi7">Szeryfowie</h3>
          <p>
            Maksymalnie 5 członków z frakcji szeryfów (lub pomocników) może
            jednocześnie uczestniczyć w walce wręcz lub strzelaninie. Aby brać
            udział w strzelaninach/walkach wręcz w grupach większych niż 5
            będzie potrzebne pozwolenie administracji. Zatwierdzenie można
            otrzymać za pośrednictwem ticket’a.
          </p>
          <h3 id="limit8">Cywile</h3>
          <p>
            Cywile nie mogą dołączyć do trwającej akcji hostylnej o podłożu
            szeryfowie/crime co spowodowałoby przewagę nad jedną ze stron.{" "}
          </p>
          <p>
            Limit 5 osób nie obowiązuje dla graczy bez zamiarów przestępczych*
            (np. podczas spotkań w mieście).
          </p>
          <p>
            Dozwolone jest podróżowanie w grupach większych niż 5 osób, jednakże
            zakazuje się podejmowania w niej akcji hostylnych wychodzących poza
            ten limit.
          </p>
          <p>
            Notoryczne jeżdżenie w grupach ponad limitem lub specjalne szukanie
            osób do przejechania w większej grupie, tylko w celu uniknięcia
            akcji z crime będzie surowo karane.
          </p>
          <p>
            W wypadku, kiedy ma dojść do podróży w grupie większej niż 5
            graczy, osoby biorące udział powinny między sobą dogadać kto w razie
            sytuacji hostylnej podejmuje się akcji. Jeśli dojdzie do akcji
            hostylnej, osoby ponad limitem starają się oddalić od miejsca zdarzenia.
          </p>
          <p>
            Crime, podejmujący się akcji z zaskoczenia w stosunku do grupy
            przekraczającej limit, musi liczyć się z tym, że każda osoba ponad
            limit będzie mogła bronić swojego bezpieczeństwa i przez dynamikę
            akcji nie będzie miała czasu na podzielenie się.
          </p>
          <p>
            Limit przewyższający 5 osób zakazuje się:
            <li>
              osobom posiadającym biznes na przejazdy aby złożyć bądź odebrać
              zamówienie
            </li>
            <li>osobom prowadzącym pociągi</li>
            <li>osobom objętych listem gończym</li>
            <li>na przejazdy szeryfów na służbie**</li>
            <li>na przejazdy lekarzy na służbie**</li>
          </p>
          <p>
            <i>
              *Osoba zamaskowana, grożąca bronią lub osoba która afiszuje się
              bronią palną jak i białą jest traktowana jak osoba z zamiarami
              przestępczymi
            </i>
            <i>
              **Wychodzenie ze służby tylko po to, aby przejechać z miejsca do
              miejsca jest zakazane i będzie karane. Osoby na okresie
              próbnym/praktykanci/powołani przez szeryfow niezatrudnieni w
              jobie, a powołani przez dane prace zaliczają sie do limitu.
            </i>
          </p>
          <h2 id="robbery">Napady</h2>
          <p>
            Jeśli grupa Crime/Szeryf zdecyduje się podczas napadu na rozpoczęcie
            strzelaniny, jest ona zobowiązana do oddania strzału ostrzegawczego
            i odczekania 10 sekund przed przystąpieniem do walki. Gdy złodzieje
            oddają swój pierwszy strzał i poczekają wskazany czas, uważa się, że
            sytuacja przeszła do walki i wszystkie strony mogą swobodnie
            angażować się do woli. Powodem tego jest to, że żaden gracz nie
            zostanie natychmiast zabity bez szansy na zaangażowanie się w RP.
            Szeryfowie nie mogą wejść do banku w celu zdjęcia wszystkich
            bandytów gdy w banku,sklepie znajdują się zakładnicy. Zakazuje się
            organizowania podstawionych zakładników na akcje hostylne.
          </p>
          <p>
            Osoby będące poza budynkiem napadu (np. na dachu innego budynku)
            również mają obowiązek do wykonania inicjacji. Podczas pościgów,
            grupa Crime/Szeryf oraz osoby ukrywające się zobowiązane są do
            oddania strzału ostrzegawczego przed przystąpieniem do strzelaniny.
          </p>
          <p>
            W przypadku kiedy szeryfowie mają realne podejrzenia że zakładnikom
            może dziać się krzywda, mają prawo wejść do środka po wcześniejszym
            poinformowaniu słownym napastników o zerwaniu negocjacji z takiego
            powodu oraz odczekaniu 10 sekund.
          </p>
          <p>
            Szeryfowie będą traktować wszystkich zakładników i bezpieczeństwo
            obywateli jako priorytet podczas jakiejkolwiek akcji hostylnej.
            Szeryfowie nie będą podejmować prób naruszenia, angażowania się lub
            ogólnie żadnego ruchu, dopóki nie zweryfikują bezpieczeństwa/śmierci
            zakładników poprzez wymianę zakładników.
          </p>
          <p>
            Osoby biorące udział w akcji hostylnej sheriff vs. crime (np. napad
            na sklep) muszą pamiętać, że ich priorytetem po jej zakończeniu jest
            ucieczka z miejsca zdarzenia, a nie przeszukiwanie i okradanie
            innych graczy (będzie to uznawane za fail RP). Tyczy się to również
            osób biorących udział w innych akcjach o podłożu crime (np. kradzież
            bydła). Uczestnicy muszą ustalić co dla nich jest ważniejsze -
            okradanie ludzi czy ich cel.
          </p>
          <p>
            Po zerwaniu negocjacji przez którąkolwiek stronę (szeryfi/bandyci),
            strona crime ma nie więcej niż 15 minut na opuszczenie miejsca napadu.
            Zakazane jest "bunkrowanie się" w danym interiorze - priorytetem
            crime jest ucieczka z miejsca zdarzenia.
          </p>
          <p>
            Napad na bank może być wykonany raz na dwa dni przez każdego gracza.
            Osoby biorące udział w danym napadzie (będące na miejscu lub będące
            na miejscu “zasadzki”) również zaliczają się do tego limitu.
          </p>
          <p>
            Napad na sklep może być wykonany dwa razy dziennie. Osoby biorące
            udział w danym napadzie (np. będące na miejscu, będące na miejscu
            “zasadzki”) również zaliczają się do tego limitu.
          </p>
          <p>
            Napad na każdy konkretny sklep (np. sklep "zielarski" w Saint Denis)
            może być wykonany raz dziennie przez daną ekipę. Osoby biorące udział
            w danym napadzie (np. będące na miejscu, będące na miejscu “zasadzki”)
            również zaliczają się do tego limitu.
          </p>
          <p>
            Zakazuje się robienia napadów w kilku miejscach jednocześnie przez
            jedną, tę samą grupę przestępczą.
          </p>
          <p>
            Zakazuje się robienia napadu 30 minut i krócej przed zaplanowanym
            restartem, jak i 30 minut i krócej po restarcie serwera.
          </p>
          <h2 id="convoy">Konwoje</h2>
          <p>
            Prawo do konwoju przysługuje zatrzymanemu tylko jeśli jego kara jest
            wysoka.np Kara śmierci lub powyżej 150 minut.Szeryf nie ma prawa
            odmówić tego żądania. W przypadku gdy do wykonania konwoju nie ma
            wystarczającej liczby szeryfów mogą wyznaczyć inny termin konwoju.
          </p>
          <p>
            Podczas konwoju jeśli osoba konwojowana zostanie uwolniona, nie może
            uczestniczyć w walce między szeryfami a bandytami, oraz powinna jak
            najszybciej oddalić się z miejsca akcji. Jeśli osoba ta dołączy do
            walki będzie to traktowanie jako przekroczenie limitów.
          </p>
          <h2 id="shops">Sklepy</h2>
          <p>
            Jedna grupa graczy (ekipa, banda, gang, rodzina, i inne powiązania) może posiadać maksymalnie jeden biznes na własność na
            terenie całego hrabstwa. Posiadanie większej ilości będzie
            skutkowało konfiskatą wszystkich sklepów danej grupy, wraz z całą
            ich zawartością. Zakazuje się kupna biznesów “na słupa”. Osobom,
            które są właścicielami biznesów, pozwala się pracować wyłącznie
            w jednym innym biznesie*. Wyjątkami od tych założeń jest konsultacja
            z administracją w formie ticket'a.
          </p>
          <p>
            Osobom, które pracują w Biurze Szeryfa/Lecznicy, pozwala się pracować (nie posiadac!)
            wyłącznie w jednym innym biznesie*.

            *(saloon, sklep wielobranżowy)

          </p>
          <p>W sklepach zakazuje się sprzedaży:</p>
          <ul>
            <li>jakiegokolwiek rodzaju broni palnej</li>
            <li>amunicji do broni</li>
            <li>
              gotowych dań i napojów, które powinny być z reguły ciepłe
              <br />
              (wyjątkiem jest kawiarnia w Saint Denis)
            </li>
          </ul>
          <p>
            Podczas sprzedawania przedmiotów i substancji nielegalnych, w
            sklepach, musisz liczyć się z tym, że szeryfowie, mogą ci ten sklep
            skonfiskować, wraz z zawartością.
          </p>
          <p>
            Jeżeli w sklepie zostają umieszczone przedmioty, po bardzo
            zawyżonych cenach np. Patyk za 500$, sklep zostaje zabrany graczowi
            przez administracje.
          </p>
          <p>
            Grawerunek wykonywany przez Rusznikarzy powinien być "robiony" przez
            minimum 24h. Wyjątkiem od tego są minimalne poprawy (powinny trwać
            2-3h), bądź dodatki wizualne (np. owijki, które powinny trwać 1h).
          </p>
          <h2 id="crime">Crime</h2>
          <p>
            Celowe prowokowanie lub zwracania na siebie uwagi szeryfów wyłącznie
            w celu rozpoczęcia brutalnej interakcji z nimi jest surowo
            zabronione. Interakcja z szeryfami oparta na walce powinna odbyć się
            w sposób naturalny. Nieprzestrzeganie tej zasady będzie surowo
            karane.
          </p>
          <p>
            Odbicie zatrzymanego z biura szeryfa, powinno być uprzednio
            zaplanowane, oraz należy pamiętać, że ważniejszym jest odbicie, niż
            to co szeryf ma na plecach. W odbiciu muszą brać udział szeryfi.
          </p>
          <p>
            Dozwolone jest podszywanie się pod urzędników państwowych, lekarzy
            jak i szeryfów. Jednak fałszowanie dokumentów lub odznak nie jest
            dozwolone. Jeśli gracz poprosi osobę podszywającą się, aby ta
            pokazała dokument/odznakę, nie może ona tego pokazać.
            Nieprzestrzeganie tej zasady będzie surowo karane.
          </p>
          <p>
            Zabronione jest magazynowanie kontrabandy w publicznych bankach.
            Trzymanie kontrabandy/nielegalnych przedmiotów w depozycie, może
            skutkować wizytacją szeryfów oraz listami gończymi.
          </p>
          <p>Zakazane jest bycie w tym samym gangu na różnych postaciach.</p>
          <p>
            Zmuszanie porwanych do otwierania skrytek bankowych (wypłata z
            banku/wyjmowanie ze schowka), skrytek w domostwach, miejscach pracy
            lub obozach gangu jest zabronione (można komuś przeszukać juki).
            Obejmuje to również przekazywania koni, wozów oraz innych sytuacji,
            w których gracz musi nam coś ,,przepisać’’ skryptowo. Jest to
            traktowane jako PG oraz FailRP.
          </p>
          <p>
            Szeryf ma prawo zaprowadzić zatrzymanego i sprawdzić jego skrytkę
            bankową w celu zażądania wypłacenia pieniędzy, jeżeli grzywna
            przestępcy wynosi powyżej 50$.
          </p>
          <p>
            Wzywanie pomocy Lekarza podczas trwającej akcji Crime jest
            traktowane jako przekroczenie limitów akcji. Konsekwencje ponosi
            strona wzywająca pomoc. Również wezwanie lekarza, tylko i wyłącznie
            w celu porwania go lub obrabowania jest surowo zakazane.
          </p>
          <p>
            Używania broni z lunetą pokroju carcano/rollingblock podczas akcji
            hostylnych jest surowo zabronione. Broń ta służy WYŁĄCZNIE do
            polowań na zwierzynę lub misje pokroju Bounty Hunting.
          </p>
          <p>
            Napaści na graczy bez inicjacji, które mają na celu tylko i
            wyłącznie zabieranie broni, rzeczy lub konia, są zabronione i będą
            surowo karane.
          </p>
          <p>
            Podczas akcji rabunkowej wobec innego gracza, zabrać można wszystko
            co ma aktualnie przy sobie, poza następującymi rzeczami:
          </p>
          <ul>
            <li>
              Jedzenie i picie(wyjątkiem są hurtowe ilości jedzenia i picia -
              należy pozostawić minimum stack każdego rodzaju)
            </li>
            <li>Napary uzdrawiające</li>
            <li>
              Szeryfowi należy pozostawić jedną broń palną
              <br />
              (Nie możemy podłożyć najtańszej broni i zabrać wszystkie, tylko
              należy pozostawić jedną broń którą szeryf posiadał. Szeryfem
              uznajemy osobę, która ma widoczną na sobie odznakę.)
            </li>
            <li>
              Odznaki szeryfa (chyba że ma się dobry powód RP i do tego osoba
              której chcesz ją zabrać wyraża na to zgodę.)
            </li>
          </ul>
          <p>
            Należy pamiętać, że jeśli chcemy okraść drugiego gracza, zróbmy to
            ze smakiem, nikt nie chce zostać okradziony z każdej broni i
            przedmiotu. Zabranie wszystkich broni nóż/lasso/lornetka, bez
            dobrego powodu (chęć zdobycia broni, nie jest wystarczającym
            powodem), będzie traktowana jako lootRP.
          </p>
          <p>
            Podczas podejmowania działań hostylnych lub wątkowych na podłożu
            Sheriff/Crime, zakazane jest uciekanie do miejsc z możliwością
            zablokowania prowadzenia dalszego wątku/akcji roleplay. Przykład:
            ucieczka do zamykanego na klucz pokoju hotelowego podczas ucieczki.
          </p>
          <p>
            Powracanie do miejsca akcji lub postaci (po BW, podniesiony przez
            lekarza czy skryptów) w celu ocalenia członka bandy lub w celu
            dokonania zemsty poprzez zabójstwo bądź pobicie, będzie traktowane
            jako Revenge Kill oraz Fail RP.
          </p>
          <p>
            Aby wyrządzić szkody trwałe (takie które osoba musi odgrywać przez
            dłuższy czas jak i ich np. odbudowę) na kogoś domu/sklepie/terenie
            musisz otrzymać zgodę od administracji(ticket). Szkody trwałe
            wyrządzone bez pozwolenia, nie muszą być odgrywane, a osoba
            wyrządzająca takie zostanie ukarana.
          </p>
          <h2 id="details">System szczegółów</h2>
          <p>
            System szczegółów może być wykorzystywany tylko do informacji, które
            są kluczowe dla fabuły i nie mogą być udostępniane za pomocą innych
            dostępnych metod rozgrywki lub komunikacji. Szczegóły powinny być
            wykorzystywane do takich rzeczy, jak zapełnianie miejsca zbrodni
            dowodami, wykazywanie oznak walki, a może pozostawienie ciekawostki,
            że gracz był niedawno w okolicy za pomocą czegoś takiego jak ciepłe
            węgle w ognisku.
          </p>
          <p>
            Szczegóły <strong>NIE</strong> powinny być wykorzystywane do:
            notatek, oznakowania i wszelkich ogólnych etykiet, które nie
            wpływają bezpośrednio na fabułę, która jest aktywnie rozgrywana na
            serwerze przez wiele osób. Niewłaściwe wykorzystanie tego systemu
            może skutkować odpowiednią surową karą.
          </p>
          <h2 id="factions">Frakcje</h2>
          <p>
            Każdy gracz, który jest wyznaczonym liderem w jakimkolwiek
            frakcji(szeryfowie, doktorzy itp.) będzie miał wyższe oczekiwania ze
            strony administracji w zakresie komunikacji, rozgrywki i
            przestrzegania zasad. Administracja zastrzega sobie prawo do
            narzucenia tych oczekiwań i wydania wskazówek OOC liderom w grze ze
            względu na wpływ liderów frakcji na serwer.
          </p>
          <p>
            Naczelny żadnej frakcji nie, może być “skorumpowany”, natomiast
            niżsi rangą, mogą, tylko po zgodzie uzyskanej od administracji.
            Lider, po dowiedzeniu się IC o tym wybryku gracza, musi natychmiast
            wydalić go z frakcji, lub ukarać go wysoką karą np. śmierć. Osoby
            będące crime we frakcji obowiązane są pociągnąć wątek IC, jeśli mają
            w zamiarze okraść swoje miejsce pracy (np. wyciągnąć ze schowka
            wszystkie pieniądze).
          </p>
          <p>
            Gracz który ma jedną postać w szeryfach, nie może grać na drugiej po
            stronie crime, wyjątki będą się, zdarzać lecz będą rzadkością,
            albowiem wymaga ona akceptacji ze strony administracji serwera.
          </p>
          <p>
            Napary podnoszące z BW są traktowane immersyjnie jako czyjaś wiedza.
            Zakazane jest używanie ich przez osoby które obecnie nie należą do
            frakcji lekarzy bądź do plemienia Indian.
          </p>
          <p>Lekarz ma prawo do użycia PG w następujących sytuacjach:</p>
          <ul>
            <li>
              rany odniesione przez gracza są na tyle poważne, że przerastają
              możliwości leczenia w 1898.
            </li>
            <li>
              pomimo zadawania pytań i chęci odegrania przez lekarza, gracz nie
              odpowiada lub/i odpowiada w niejasny sposób.
            </li>
          </ul>
          <p>Przy odgrywaniu medRP lekarz odpowiada za:</p>
          <ul>
            <li>swoje umiejętności </li>
            <li>
              następstwa wykonywanych przez siebie zabiegów/czynności np. czy po
              szwach zostanie blizna, wytrzymałość szwów
            </li>
            <li>
              działanie medykamentów, tj. jeżeli został podany lek i lekarz
              wysyła na /do jego działanie, to gracz jest zobowiązany do
              odegrania działania danego leku. Jedynym przypadkiem gdy gracz
              może nie odegrać działania medykamentu, jest użycie - /try dawka
              leku/medykamentu była za mała by zadziałać (bo metabolizm takiego
              leku może być osobniczy)
            </li>
          </ul>
          <p>Przy odgrywaniu medRP gracz odpowiada za:</p>
          <ul>
            <li>odniesione przez postać rany </li>
            <li>proces gojenia rany</li>
            <li>
              reakcje organizmu na rany/wykonywane zabiegi/podawane środki np.
              skrzywienie się na polanie rany alkoholem, gwałtowne przebudzenie
              po solach trzeźwiących
            </li>
          </ul>
        </div>
        <div className="grid-item"></div>
      </section>
      <Footer />
    </div>
  );
}

export default Rules;
